import * as React from 'react';
import {
  Heading, Row, Col, Button,
} from '@elevationscu/ui-component-lib';
import InputRequest from './input-request';
import styles from './property-type.module.scss';
import ProgressBar from './ProgressBar';
import DataDisclaimer from './data-disclaimer';
import { PROPERTY_TYPES, PROPERTY_USES } from './constants';
import SelectableButton from './SelectableButton';

export default function PropertyType({
  pageNumber, userInfo, setUserInfo, nextPage, previousPage, maxPages,
}) {
  const [chosenPropType, setChosenPropType] = React.useState([]);
  const [chosenPropUse, setChosenPropUse] = React.useState();
  const [validatedProps, setValidatedProps] = React.useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = React.useState({});

  React.useEffect(() => {
    if (userInfo.application_data.property_type) setChosenPropType(userInfo.application_data.property_type);
    if (userInfo.application_data.property_usage) setChosenPropUse(userInfo.application_data.property_usage);

    userInfo.application_data.property_type?.forEach((type) => {
      selectedPropertyTypes[type] = true;
    });
    // eslint-disable-next-line
    },[])

  React.useEffect(() => {
    const tempArray = [];
    Object.entries(selectedPropertyTypes).forEach(([key, value]) => {
      if (value === true) {
        tempArray.push(key);
      }
    });
    setChosenPropType(tempArray);
    // eslint-disable-next-line
    }, [selectedPropertyTypes])

  React.useEffect(() => {
    if (chosenPropType.length !== 0 && chosenPropUse) {
      setValidatedProps(true);
    } else {
      setValidatedProps(false);
    }
  }, [chosenPropType, chosenPropUse, userInfo.application_data]);

  function selectPropertyType(propertyType) {
    setSelectedPropertyTypes({ ...selectedPropertyTypes, [propertyType]: !selectedPropertyTypes[propertyType] });
  }

  function selectPropertyUsage(propertyUse) {
    setChosenPropUse(propertyUse);
    userInfo.application_data = Object.assign(userInfo.application_data, {
      property_usage: propertyUse,
    });
  }

  function next() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      property_type: chosenPropType,
    });
    setUserInfo(userInfo);
    nextPage(userInfo);
  }

  function previous() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      property_usage: chosenPropUse,
      property_type: chosenPropType,
    });
    setUserInfo(userInfo);
    previousPage(userInfo);
  }

  return (
    <div className={styles.mainContainer}>

      <div className={styles.coreData}>
        <div className={styles.coreHeader}>
          <Heading element="h1" size={2} className={styles.heading}>
            What kind of property are you buying?
          </Heading>
          <InputRequest />
        </div>
        <div className={styles.prospectInput}>
          <ProgressBar pageNumber={pageNumber} maxPages={maxPages} />
          <fieldset className={styles.fieldset}>
            <legend>
              <Heading element="h2" size={3} className={styles.subHeading}>
                Please tell us about the property you'd like to purchase. (required)
              </Heading>
            </legend>
            <Row className={styles.propertyRow}>
              <div className={styles.selectableButtonRow}>
                {
                  PROPERTY_TYPES.map((propertyType) => (
                    <SelectableButton
                      id={`${propertyType}_btn`}
                      label={propertyType}
                      onChange={() => { selectPropertyType(propertyType); }}
                      checked={selectedPropertyTypes[propertyType] === true}
                    />
                  ))
              }
              </div>
            </Row>
          </fieldset>
          <Heading element="h2" size={3} className={styles.subHeading}>
            Please tell us how you'll use this property. (required)
          </Heading>
          <Row className={styles.propertyRow}>
            {PROPERTY_USES.map((propertyUse) => (
              <Button
                id={`${propertyUse}_btn`}
                onClick={() => selectPropertyUsage(propertyUse)}
                variant="secondary"
                className={propertyUse === chosenPropUse ? styles.chosenPropTypeBtn : styles.button}
              >
                {propertyUse}
              </Button>
            ))}
          </Row>
          <Row className={styles.rowSpacing}>
            <Col lg={8}>
              <DataDisclaimer />
            </Col>
            <Col className={styles.colSpacing}>
              <button onClick={previous} className={styles.previousButton} id="previous_btn" type="button">
                Previous
              </button>
              <Button onClick={next} disabled={!validatedProps} className={styles.nextButton} id="next_btn">
                Next
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
